import styled from "styled-components"
import Colors from "./Colors"
import { breakpointsMax } from "./Common"

const SmInfos = styled.div`
    font-family: "EB Garamond", serif;
    font-size: 20px;
    font-weight: 500;
    color: ${Colors.peach};
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
`

const Contact = styled.div`
    font-family: "EB Garamond", serif;
    font-size: 20px;
    @media ${breakpointsMax.tablet} {
        font-size: 18px;
    }
    font-weight: 600;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    color: ${Colors.peach};
`

const NavLink = styled.div`
    font-family: "EB Garamond", serif;
    font-size: ${(props) => (props.sm ? "17px" : "22px")};
    font-weight: ${(props) => (props.active ? 600 : 500)};
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    color: ${Colors.red};
    border-bottom: ${(props) =>
        props.active ? `1px solid ${Colors.red}` : ""};
    padding-bottom: ${(props) => (props.active ? `4px` : "0px")};
`

const HeroText = styled.div`
    font-family: "EB Garamond", serif;
    font-size: ${(props) => (props.sm ? "30px" : "75px")};
    @media ${breakpointsMax.mobileS} {
        font-size: ${(props) => (props.sm ? "3.5vw" : "10vw")};
    }

    @media ${breakpointsMax.mobileM} {
        font-size: ${(props) => (props.sm ? "3.5vw" : "10vw")};
    }

    @media ${breakpointsMax.mobileL} {
        font-size: ${(props) => (props.sm ? "3.5vw" : "10vw")};
    }

    @media ${breakpointsMax.tablet} {
        font-size: ${(props) => (props.sm ? "3.5vw" : "10vw")};
    }
    font-weight: ${(props) => (props.sm ? "normal" : 600)};
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: center;
    color: ${Colors.red};
`

const SectionBody = styled.div`
    font-family: "EB Garamond", serif;
    font-size: 22px;
    font-weight: ${(props) => (props.fontWeight ? props.fontWeight : "normal")};
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: ${(props) => (props.align === "right" ? "right" : "left")};
    color: ${(props) => props.textColor};
`

const SectionTitle = styled.div`
    font-family: "EB Garamond", serif;
    font-size: 45px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    font-weight: 500;
    color: ${Colors.red};
`

const Product = styled.div`
    font-family: "EB Garamond", serif;
    font-size: 25px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    color: ${Colors.white};
`

const FooterLogo = styled.div`
    font-family: "EB Garamond", serif;
    font-size: 45px;
    font-weight: 400;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: center;
    color: ${Colors.peach};
`

export {
    SmInfos,
    Contact,
    NavLink,
    HeroText,
    SectionBody,
    SectionTitle,
    Product,
    FooterLogo,
}
